import styled, { css } from 'styled-components';

import { Grid } from '@/components/Grid';
import { px2rem } from '@/theme';

import { Container } from '../Container';
import { Flex } from '../Flex';
import { ProductCard } from '../ProductCard';

export const Wrapper = styled(Container)`
  padding-inline: 0;
`;
export const HitsWrapper = styled(Grid)<{ col: number }>`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  width: 100%;
  ${({ col, theme }) => css`
    gap: ${theme.spacing(1)};

    ${theme.media.md.up} {
      grid-template-columns: repeat(
        ${col},
        calc((100% - ${theme.spacing((col - 1) * 2.5)}) / ${col})
      );
      gap: ${theme.spacing(3)};
    }
  `}
`;

export const ImageWrapper = styled(Flex)`
  min-height: ${px2rem(240)};
  width: 100%;
`;

export const ProductCardDetails = styled(ProductCard.Details)`
  && {
    text-align: left;
    align-items: start;
    justify-content: space-around;
  }
`;
